import {Component, OnInit, TemplateRef} from '@angular/core';
import {APIHelper} from "../../../apihelper";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {SharedResources} from "../../../shared-resources";
import {Orders} from "../../../models/orders";
import {MatSnackBar} from '@angular/material/snack-bar';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-process-order',
  templateUrl: './process-order.component.html',
  styleUrls: ['./process-order.component.css']
})
export class ProcessOrderComponent implements OnInit {
  code: string = '';
  codeType: string = 'SN';
  currentLinePage:number = 1;
  numberOfLinePages: number = 0;
  currentScannedCodes: Map<string, any> = new Map<string, any>();
  lines: Map<string, number> = new Map<string, number>();
  order: Orders = new Orders();
  currentSelectedLine: string = '';
  isProcessing: boolean = false;
  currentModifiableLine: string = '';
  numberOfOrderPagesSN:  number = 0;
  currentOrderPageSN: number = 1;
  numberOfOrderPagesMAC: number = 0;
  currentOrderPageMAC: number = 1;
  currentNetWeight: number = 0;
  currentGrossWeight: number = 0;
  constructor(private http: HttpClient, private _snackBar: MatSnackBar, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.order = SharedResources.currentProcessedOrder;
    this.http.get<any>(`${APIHelper.APIUrl}orderscan?OrderId=${this.order.Id}`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        for (let olc of response.OrderLineCodes) {
          this.lines.set(olc.PartNo.toUpperCase() + '\t' + olc.PartName.toUpperCase(), olc.Cantitate);
          this.currentScannedCodes.set(olc.PartNo.toUpperCase() + '\t' + olc.PartName.toUpperCase(), {
            "sn" : olc.SN,
            "mac" : olc.MAC,
          });

        }
        this.numberOfLinePages = (response.OrderLineCodes.length % 3 == 0) ? (response.OrderLineCodes.length / 3) : (Math.floor(response.OrderLineCodes.length / 3) + 1);
        console.log(response.OrderLineCodes);
        }, (error: any) => {
        alert("Eroare la încărcarea comenzii!");
        SharedResources._isLoadingBS.next(false);
      });
  }

  processCode() {
    if (this.code == '') {
      let audio = new Audio();
      audio.src = "../../assets/wrong.wav";
      audio.load();
      audio.play();
      let snackBarRef = this._snackBar.open('Câmpul nu a fost completat!', 'Închide', {
        duration: 3000
      });
      //alert('Câmpul nu a fost completat!');
      return;
    }
    if (this.codeType == '') {
      let audio = new Audio();
      audio.src = "../../assets/wrong.wav";
      audio.load();
      audio.play();
      let snackBarRef = this._snackBar.open('Tipul de cod nu a fost ales!', 'Închide', {
        duration: 3000
      });
      //alert('Tipul de cod nu a fost ales!');
      return;
    }
    if (this.currentSelectedLine == '') {
      let audio = new Audio();
      audio.src = "../../assets/wrong.wav";
      audio.load();
      audio.play();
      let snackBarRef = this._snackBar.open('Linia nu a fost aleasă!', 'Închide', {
        duration: 3000
      });
      //alert('Linia nu a fost aleasă!');
      return;
    }
    SharedResources._isLoadingBS.next(true);
    this.isProcessing = true;
    this.http.post<any>(`${APIHelper.APIUrl}orderscan`,
      {
        PartNo: this.currentSelectedLine.split('\t')[0],
        PartName: this.currentSelectedLine.split('\t')[1],
        OrderId: this.order.Id,
        TipCod: this.codeType,
        GreutateNeta: this.currentNetWeight > 0 ? this.currentNetWeight : null,
        GreutateBruta: this.currentGrossWeight > 0 ? this.currentGrossWeight : null,
        Cod: this.code
      },
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        try {
          if (this.codeType == 'SN') {
            for (let c of response.codes) {
              this.currentScannedCodes.get(this.currentSelectedLine).sn.push({
                Item1 : c,
                Item2 : this.currentNetWeight > 0 ? this.currentNetWeight : null,
                Item3 : this.currentGrossWeight > 0 ? this.currentGrossWeight : null,
              });
            }
          } if (this.codeType == 'MAC') {
            for (let c of response.codes) {
              this.currentScannedCodes.get(this.currentSelectedLine).mac.push({
                Item1 : c,
                Item2 : this.currentNetWeight > 0 ? this.currentNetWeight : null,
                Item3 : this.currentGrossWeight > 0 ? this.currentGrossWeight : null,
              });
            }
          }
          this.isProcessing = false;
          this.code = '';
          let audio = new Audio();
          audio.src = "../../assets/ok.wav";
          audio.load();
          audio.play();
          let snackBarRef = this._snackBar.open(`Au fost scanate ${response.codes.length} coduri!`, 'Închide', {
            duration: 3000
          });
          SharedResources._isLoadingBS.next(false);
        } catch (e) {
          this.isProcessing = false;
          this.code = '';
          SharedResources._isLoadingBS.next(false);
          let audio = new Audio();
          audio.src = "../../assets/wrong.wav";
          audio.load();
          audio.play();
          SharedResources._isLoadingBS.next(false);
          let snackBarRef = this._snackBar.open("Nici un cod scanat!", 'Închide', {
            duration: 3000
          });
        }



      }, (error: any) => {

      });


  }

  selectLine(key: string) {
    this.currentSelectedLine = key;
  }

  goToPrevPage() {
    if (this.currentLinePage == 1) {
      this.currentLinePage = this.numberOfLinePages;
    } else {
      this.currentLinePage -= 1;
    }
  }

  goToNextPage() {
    if (this.currentLinePage == this.numberOfLinePages) {
      this.currentLinePage = 1;
    } else {
      this.currentLinePage += 1;
    }
  }

  getLinePage() {
    return Array.from(this.lines.keys()).filter(
      (value: string, index:number) => index >= (this.currentLinePage - 1) * 3 && index <= this.currentLinePage * 3 - 1);
  }

  editLineScans(modalLinesScans: TemplateRef<any>, key: string) {
    this.currentModifiableLine = key;
    this.currentOrderPageSN = 1;
    this.numberOfOrderPagesSN = this.currentScannedCodes.get(key).sn.length % 3 == 0 ?
      Math.floor(this.currentScannedCodes.get(key).sn.length / 3) : (Math.floor(this.currentScannedCodes.get(key).sn.length / 3) + 1);
    this.currentOrderPageMAC = 1;
    this.numberOfOrderPagesMAC = this.currentScannedCodes.get(key).mac.length % 3 == 0 ?
      Math.floor(this.currentScannedCodes.get(key).mac.length / 3) : (Math.floor(this.currentScannedCodes.get(key).mac.length / 3) + 1);
    this.modalService.open(modalLinesScans, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard:false}).result.then(
      (result) => {
      },
      (reason) => {
      });
  }

  getSNPage() {
    return this.currentScannedCodes.get(this.currentModifiableLine.toUpperCase()).sn.filter(
      (value: any, index:number) => index >= (this.currentOrderPageSN - 1) * 3 && index <= this.currentOrderPageSN * 3 - 1);
  }

  deleteSN(sn: string) {
    SharedResources._isLoadingBS.next(true);
    this.http.delete<any>(`${APIHelper.APIUrl}orderscan?PartNo=${encodeURIComponent(this.currentModifiableLine.split('\t')[0])}&OrderId=${this.order.Id}&TipCod=SN&Cod=${encodeURIComponent(sn)}&PartName=${encodeURIComponent(this.currentModifiableLine.split('\t')[1])}`,

      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe((response:any) => {
        this.currentScannedCodes.get(this.currentModifiableLine).sn
          = this.currentScannedCodes.get(this.currentModifiableLine).sn.filter((value: any) =>{
          return value.Item1 != sn;
        });
        this.numberOfOrderPagesSN = this.currentScannedCodes.get(this.currentModifiableLine).sn.length % 3 == 0 ?
          Math.floor(this.currentScannedCodes.get(this.currentModifiableLine).sn.length / 3) : (Math.floor(this.currentScannedCodes.get(this.currentModifiableLine).sn.length / 3) + 1);
        if (this.currentOrderPageSN > this.numberOfOrderPagesSN) {
          this.currentOrderPageSN = 1;
        }
        SharedResources._isLoadingBS.next(false);
      }, (error:any) => {
        alert('A apărut o eroare la ștergerea codului!');
        SharedResources._isLoadingBS.next(false);
      });
  }

  goToPrevPageSN() {
    this.currentOrderPageSN--;
    if (this.currentOrderPageSN == 0) {
      this.currentOrderPageSN = this.numberOfOrderPagesSN;
    }
  }

  goToNextPageSN() {
    this.currentOrderPageSN++;
    if (this.currentOrderPageSN > this.numberOfOrderPagesSN) {
      this.currentOrderPageSN = 1;
    }
  }

  getMACPage() {
    return this.currentScannedCodes.get(this.currentModifiableLine.toUpperCase()).mac.filter(
      (value: number, index:number) => index >= (this.currentOrderPageMAC - 1) * 3 && index <= this.currentOrderPageMAC * 3 - 1);
  }

  deleteMAC(mac: string) {
    SharedResources._isLoadingBS.next(true);
    this.http.delete<any>(`${APIHelper.APIUrl}orderscan?PartNo=${encodeURIComponent(this.currentModifiableLine)}&OrderId=${this.order.Id}&TipCod=MAC&Cod=${encodeURIComponent(mac)}`,

      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe((response:any) => {
      this.currentScannedCodes.get(this.currentModifiableLine).mac
        = this.currentScannedCodes.get(this.currentModifiableLine).mac.filter((value: any) =>{
        return value.Item1 != mac;
      });
      this.numberOfOrderPagesMAC = this.currentScannedCodes.get(this.currentModifiableLine).mac.length % 3 == 0 ?
        Math.floor(this.currentScannedCodes.get(this.currentModifiableLine).mac.length / 3) : (Math.floor(this.currentScannedCodes.get(this.currentModifiableLine).mac.length / 3) + 1);
      if (this.currentOrderPageMAC > this.numberOfOrderPagesMAC) {
        this.currentOrderPageMAC = 1;
      }
      SharedResources._isLoadingBS.next(false);
    }, (error:any) => {
      alert('A apărut o eroare la ștergerea codului!');
      SharedResources._isLoadingBS.next(false);
    });
  }

  goToPrevPageMAC() {
    this.currentOrderPageMAC--;
    if (this.currentOrderPageMAC == 0) {
      this.currentOrderPageMAC = this.numberOfOrderPagesMAC;
    }
  }

  goToNextPageMAC() {
    this.currentOrderPageMAC++;
    if (this.currentOrderPageMAC > this.numberOfOrderPagesMAC) {
      this.currentOrderPageMAC = 1;
    }
  }

  applyLinesDetailsModifications(modalLinesDetails: any) {
    modalLinesDetails.dismiss();
  }

  closeProcessing() {
    SharedResources.currentScreen = 'orders';
    SharedResources._currentScreenBS.next(SharedResources.currentScreen);
  }

  finalizeOrder() {
    if (confirm(`Sunteți sigur(ă) că vreți să finalizați comanda?`)) {
      this.order.Stare = "Finalizată";
      this.http.put<any>(`${APIHelper.APIUrl}order`,
        this.order,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('token')}`
          })
        }).subscribe(
        (response: any) => {
          alert("Comanda s-a finalizat cu succes!");
          SharedResources._isLoadingBS.next(false);
          SharedResources.currentScreen = 'orders';
          SharedResources._currentScreenBS.next(SharedResources.currentScreen);
        }, (error: any) => {
          alert(error.error);
          SharedResources._isLoadingBS.next(false);
        });
    }

  }

  changeMACWeightNet(mac: any) {
    let newWeight = prompt("Introduceți noua greutate netă(KG)", mac.Item2 == null ? "" : mac.Item2);
    if (newWeight == null) {
      //alert("Format incorect!");
      return;
    }
    if (isNaN(Number(newWeight))) {
      alert("Format incorect!");
      return;
    }
    if (Number(newWeight) <= 0) {
      alert("Format incorect!");
      return;
    }
    SharedResources._isLoadingBS.next(true);

    this.http.put<any>(`${APIHelper.APIUrl}updatemacweight?Cod=${mac.Item1}` +
      `&PartName=${this.currentModifiableLine.split('\t')[1]}` +
      `&PartNo=${this.currentModifiableLine.split('\t')[0]}` +
      `&OrderId=${this.order.Id}` +
      `&GreutateNeta=${newWeight}` +
      ((mac.Item3 == null) ? `` : `&GreutateBruta=${mac.Item3}`),
      "",
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
          this.currentScannedCodes.get(this.currentModifiableLine).mac =
            this.currentScannedCodes.get(this.currentModifiableLine).mac.map(
              (o : any) => {
                if (o.Item1 == mac.Item1) {
                  mac.Item2 = Number(newWeight);
                  return mac;
                } else {
                  return o;
                }
              });
        SharedResources._isLoadingBS.next(false);
      },
      (error :any) => {
        alert("Eroare la modificare!");
        SharedResources._isLoadingBS.next(false);
      })


  }

  changeMACWeightGross(mac: any) {
    let newWeight = prompt("Introduceți noua greutate brută(KG)", mac.Item3 == null ? "" : mac.Item3);
    if (newWeight == null) {
      //alert("Format incorect!");
      return;
    }
    if (isNaN(Number(newWeight))) {
      alert("Format incorect!");
      return;
    }
    if (Number(newWeight) <= 0) {
      alert("Format incorect!");
      return;
    }

    this.http.put<any>(`${APIHelper.APIUrl}updatemacweight?Cod=${mac.Item1}` +
      `&PartName=${this.currentModifiableLine.split('\t')[1]}` +
      `&PartNo=${this.currentModifiableLine.split('\t')[0]}` +
      `&OrderId=${this.order.Id}` +
      `&GreutateBruta=${newWeight}` +
      ((mac.Item2 == null) ? `` : `&GreutateNeta=${mac.Item2}`),
      "",
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.currentScannedCodes.get(this.currentModifiableLine).mac =
          this.currentScannedCodes.get(this.currentModifiableLine).mac.map(
            (o : any) => {
              if (o.Item1 == mac.Item1) {
                mac.Item3 = Number(newWeight);
                return mac;
              } else {
                return o;
              }
            });
        SharedResources._isLoadingBS.next(false);
      },
      (error :any) => {
        alert("Eroare la modificare!");
        SharedResources._isLoadingBS.next(false);
      })

  }

  changeSNWeightNet(sn: any) {
    let newWeight = prompt("Introduceți noua greutate netă(KG)", sn.Item2 == null ? "" : sn.Item2);
    if (newWeight == null) {
      //alert("Format incorect!");
      return;
    }
    if (isNaN(Number(newWeight))) {
      alert("Format incorect!");
      return;
    }
    if (Number(newWeight) <= 0) {
      alert("Format incorect!");
      return;
    }
    SharedResources._isLoadingBS.next(true);

    this.http.put<any>(`${APIHelper.APIUrl}updatesnweight?Cod=${sn.Item1}` +
      `&PartName=${this.currentModifiableLine.split('\t')[1]}` +
      `&PartNo=${this.currentModifiableLine.split('\t')[0]}` +
      `&OrderId=${this.order.Id}` +
      `&GreutateNeta=${newWeight}` +
      ((sn.Item3 == null) ? `` : `&GreutateBruta=${sn.Item3}`),
      "",
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.currentScannedCodes.get(this.currentModifiableLine).sn =
          this.currentScannedCodes.get(this.currentModifiableLine).sn.map(
            (o : any) => {
              if (o.Item1 == sn.Item1) {
                sn.Item2 = Number(newWeight);
                return sn;
              } else {
                return o;
              }
            });
        SharedResources._isLoadingBS.next(false);
      },
      (error :any) => {
        alert("Eroare la modificare!");
        SharedResources._isLoadingBS.next(false);
      })


  }

  changeSNWeightGross(sn: any) {
    let newWeight = prompt("Introduceți noua greutate brută(KG)", sn.Item3 == null ? "" : sn.Item3);
    if (newWeight == null) {
      //alert("Format incorect!");
      return;
    }
    if (isNaN(Number(newWeight))) {
      alert("Format incorect!");
      return;
    }
    if (Number(newWeight) <= 0) {
      alert("Format incorect!");
      return;
    }

    this.http.put<any>(`${APIHelper.APIUrl}updatesnweight?Cod=${sn.Item1}` +
      `&PartName=${this.currentModifiableLine.split('\t')[1]}` +
      `&PartNo=${this.currentModifiableLine.split('\t')[0]}` +
      `&OrderId=${this.order.Id}` +
      `&GreutateBruta=${newWeight}` +
      ((sn.Item2 == null) ? `` : `&GreutateNeta=${sn.Item2}`),
      "",
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        this.currentScannedCodes.get(this.currentModifiableLine).sn =
          this.currentScannedCodes.get(this.currentModifiableLine).sn.map(
            (o : any) => {
              if (o.Item1 == sn.Item1) {
                sn.Item3 = Number(newWeight);
                return sn;
              } else {
                return o;
              }
            });
        SharedResources._isLoadingBS.next(false);
      },
      (error :any) => {
        alert("Eroare la modificare!");
        SharedResources._isLoadingBS.next(false);
      })

  }
}
